import React from "react";

const CheckboxGroup = ({
  options = [],
  name,
  values = [],
  onChange,
  multiple = false,
  className = "",
}) => {
  const handleChange = (e) => {
    const { value, checked } = e.target;
    if (multiple) {
      // Multi-select: add/remove value from array
      if (checked) {
        onChange([...values, value]);
      } else {
        onChange(values.filter((v) => v !== value));
      }
    } else {
      // Single-select: only one value
      onChange(value, checked);
    }
  };

  return (
    <div className={className}>
      {options.map((opt) => {
        return <div className="form-check" key={opt.value}>
          <input
            className="form-check-input"
            type={"checkbox"}
            name={name}
            id={`${name}_${opt.value}`}
            value={opt.value}
            checked={values.includes(opt.value)}
            onChange={handleChange}
          />
          <label className="form-check-label" htmlFor={`${name}_${opt.value}`}>
            {opt.label}
          </label>
        </div>
})}
    </div>
  );
};

export default CheckboxGroup;